import type { ReactNode } from 'react'
import { SimpleDialog } from './ui/dialog'

interface Props {
  title: string
  onClose: () => void
  children: ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

// Kept as a thin re-export of the shared Dialog primitive so every existing call site
// (ConfirmDialog, AccountProfileModal, AddEventModal, ...) gets focus trap / Esc / focus-return
// for free without changing a single prop.
export function Modal({ title, onClose, children, size = 'md' }: Props) {
  return (
    <SimpleDialog title={title} onClose={onClose} size={size}>
      {children}
    </SimpleDialog>
  )
}
